/**
 * The Iterator will iterate the subject's object graph and call the onIterateSubject method for
 * each item in the graph. It's the subject's responsibility to define the graph, and the iterator's
 * responsibility to take action on each item. Derived iterators can override the onIterateSubject
 * method and implement the action, or delegate to the user by executing a callback function.
 *
 * The difference betweeen Iterator and Visitor is that the Iterator cannot customize how the subject's
 * object graph is iterated/visited, and takes the same action for each item in the graph. A Visitor
 * base class has the freedom to override the order and which items to visit, and the items will execute
 * different callbacks for each type of item.
 */
export class Iterator {
  onIterateSubject(subject) {
  }
  iterate(subject) {
    this.onIterateSubject(subject);
    subject.iterate(this);
  }
}

export class DetachFromDomIterator extends Iterator {
  onIterateSubject(subject) {
    subject.detachFromUI();
  }
}


export class CustomIterator extends Iterator {
  constructor(onEachSubject) {
    super();
    this.onEachSubject = onEachSubject;
  }

  onIterateSubject(subject) {
    this.onEachSubject(subject);
  }
}